import config from 'react-global-configuration';
import configuration from './commonconfig';

import {loadState, saveState} from "./helpers/localstorage";

import axios from 'axios';

axios.defaults.withCredentials = true;
//set user headers
const logedInUser = loadState('user');

if (logedInUser && typeof logedInUser.token != 'undefined') {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + logedInUser.token;
}
config.set(configuration.site);
